import React, { useState } from "react";
import * as XLSX from "xlsx";
import { useUserCollectionData } from "./hooks/useUserCollectionData";

export default function ExportCollectionModal({ show, onClose, user }) {
  const [onlyForSale, setOnlyForSale] = useState(false);

  const { data, loading } = useUserCollectionData({
    userId: user?.id,
    onlyForSale,
  });

  if (!show) return null;

  const exportToExcel = () => {
    if (!data.length) return;

    const exportRows = data.map(item => ({
      Name: item.name,
      Brand: item.brand,
      Set: item.set_name,
      Year: item.year,
      Category: item.category_name,
      Subcategory: item.subcategory_name,
      Condition: item.condition,
      "Price Paid": item.price_paid,
      "Estimated Value": item.estimated_value,
      "For Sale": item.for_sale ? "Yes" : "No",
      Notes: item.extra_data
        ? Object.entries(item.extra_data)
            .map(([k, v]) => `${k}: ${v}`)
            .join(", ")
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "My Collection");

    XLSX.writeFile(workbook, "my_collection.xlsx");
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: "420px", padding: "1.5rem" }}
      >
        <h3>Export My Collection</h3>

        <label style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
          <input
            type="checkbox"
            checked={onlyForSale}
            onChange={(e) => setOnlyForSale(e.target.checked)}
          />
          Export only items marked “For Sale”
        </label>

        <div style={{ display: "flex", gap: "0.5rem" }}>
          <button onClick={exportToExcel} disabled={loading}>
            {loading ? "Preparing..." : "Export to Excel"}
          </button>
          <button className="btn-danger" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
